import React, { Component } from 'react';
import {
  Box,
  Typography,
  Breadcrumbs,
  Link,
  Card,
  CardContent,
  Switch,
  IconButton,
  Avatar,
  Stack,
  Divider,
  CircularProgress,
  Button,
  Chip,
} from '@mui/material';
import {
  Print as PrintIcon,
  Wifi as WifiIcon,
  WifiOff as WifiOffIcon,
  Autorenew as AutorenewIcon,
  FlashOn as FlashOnIcon,
  CheckCircle as CheckCircleIcon,
  RadioButtonUnchecked as RadioButtonUncheckedIcon,
} from '@mui/icons-material';

class DispositivosPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      impressorasAtivo: true,
      imprimirAutoAtivo: true,
      isConnected: false,
      isConnecting: true,
      version: '1.0.0',
      printers: [],
      selectedPrinter: null,
    };
    this.ws = null;
    this.reconnectTimer = null;
  }

  componentDidMount() {
    this.connectWebSocket();
  }

  componentWillUnmount() {
    if (this.reconnectTimer) clearTimeout(this.reconnectTimer);
    if (this.ws) {
      this.ws.onclose = null; // Evita loop de reconexão no unmount
      this.ws.close();
    }
  }

  connectWebSocket = () => {
    this.setState({ isConnecting: true });

    try {
      this.ws = new WebSocket('ws://127.0.0.1:41520');

      this.ws.onopen = () => {
        this.setState({ isConnected: true, isConnecting: false });
        // Solicita a lista atualizada de impressoras assim que conecta
        this.requestPrinterList();
      };

      this.ws.onmessage = (event) => {
        try {
          const data = JSON.parse(event.data);
          this.handleWebSocketMessage(data);
        } catch (e) {
          console.error('Erro ao processar mensagem do WebSocket:', e);
        }
      };

      this.ws.onclose = () => {
        this.setState({
          isConnected: false,
          isConnecting: false,
          printers: [],
          selectedPrinter: null,
        });
        // Tenta reconectar automaticamente após 3 segundos
        this.reconnectTimer = setTimeout(this.connectWebSocket, 3000);
      };

      this.ws.onerror = (error) => {
        console.error('Erro no WebSocket:', error);
        this.ws.close();
      };
    } catch (e) {
      this.setState({ isConnected: false, isConnecting: false });
      this.reconnectTimer = setTimeout(this.connectWebSocket, 3000);
    }
  };

  handleWebSocketMessage = (data) => {
    switch (data.type) {
      case 'status':
        this.setState({ version: data.version || '1.0.0' });
        break;

      case 'printers':
        this.setState({
          printers: data.list || [],
          selectedPrinter: data.selected || null,
        });
        break;

      case 'printer_set':
        if (data.success) {
          this.setState({ selectedPrinter: data.printer });
        }
        break;

      default:
        break;
    }
  };

  requestPrinterList = () => {
    if (this.ws && this.ws.readyState === WebSocket.OPEN) {
      this.ws.send(JSON.stringify({ type: 'list_printers' }));
    }
  };

  handleSelectPrinter = (printer) => {
    if (this.ws && this.ws.readyState === WebSocket.OPEN) {
      this.ws.send(
        JSON.stringify({
          type: 'set_printer',
          printer: printer.name,
        })
      );
    }
  };

  handleTestPrint = () => {
    if (this.ws && this.ws.readyState === WebSocket.OPEN) {

      var print = localStorage.getItem('print');

      if (print != null) {
        this.ws.send(
          JSON.stringify({
            type: 'print',
            printer: print,

            data:
              "\\x1b\\x42\\x03\\x02\\x1b\\x61\\x01--------------------------------\n" +
              "\\x1b\\x45\\x01\\x1b\\x21\\x30[ DELIVERY ]\nPEDIDO #1042\n\\x1b\\x21\\x00" +
              "--------------------------------\n" +
              "\\x1b\\x61\\x00HORA: 19:45  |  CLIENTE: JOAO\n" +
              "================================\n" +
              "\\x1b\\x45\\x01\\x1b\\x21\\x301x X-BURGER\n\\x1b\\x21\\x00" +
              "\\x1b\\x45\\x01   * PONTO: AO PONTO\n   * SEM CEBOLA\n\\x1b\\x45\\x00" +
              "--------------------------------\n" +
              "\\x1b\\x45\\x01\\x1b\\x21\\x301x BATATA G\n\\x1b\\x21\\x00" +
              "\\x1b\\x45\\x01   * ADD: CHEDDAR/BACON\n\\x1b\\x45\\x00" +
              "--------------------------------\n" +
              "\\x1b\\x45\\x01\\x1b\\x21\\x302x COCA ZERO\n\\x1b\\x21\\x00" +
              "================================\n" +
              "\\x1b\\x45\\x01\\x1b\\x21\\x20OBSERVACOES:\n" +
              "\\x1b\\x21\\x30MAIONESE EXTRA!\\x1b\\x21\\x00\\x1b\\x45\\x00\n" +
              "================================\n\n\n\n"
          })
        );
      } else {
        this.ws.send(
          JSON.stringify({
            type: 'print',
            data:
              '\x1B\x40' +
              '\x1B\x61\x01' +
              '\x1B\x42\x02\x01' +
              '[ VIA COZINHA ]\n' +
              'TESTE 1\n' +
              'TESTE 2\n' +
              'TESTE 3\n' +
              '--------------------------------\n' +
              'PEDIDO #7\n' +
              'TIPO: DELIVERY\n' +
              '--------------------------------\n' +
              'Cliente: PAULO\n' +
              'Telefone: (11) 12345-6789\n' +
              'Endereco:\n' +
              'Rua Machadinho, 143\n' +
              'Jardim Joandra\n' +
              'Ref: casa\n' +
              '--------------------------------\n' +
              'ITENS\n' +
              '--------------------------------\n' +
              '1x Marmita Pequena\n' +
              'OBS: com cebola\n' +
              '--------------------------------\n' +
              'Tempo estimado: 20 - 40 min\n' +
              'Obrigado pela preferencia!\n' +
              '\x1B\x42\x02\x01'
          })
        );
      }


    }
  };

  handleImpressorasChange = (event) => {
    this.setState({ impressorasAtivo: event.target.checked });
  };

  handleImprimirAutoChange = (event) => {
    this.setState({ imprimirAutoAtivo: event.target.checked });
  };

  render() {
    const {
      impressorasAtivo,
      imprimirAutoAtivo,
      isConnected,
      isConnecting,
      version,
      printers,
      selectedPrinter,
    } = this.state;

    return (
      <Box sx={{ minHeight: '100vh' }}>
        {/* Breadcrumbs e Título Principal */}
        <Box mb={3}>
          <Breadcrumbs separator="/" aria-label="breadcrumb" sx={{ fontSize: '0.875rem', mb: 1 }}>
            <Link underline="hover" color="inherit" href="#">
              Início
            </Link>
            <Link underline="hover" color="inherit" href="#">
              Configurações
            </Link>
            <Typography color="text.secondary" fontSize="0.875rem">
              Dispositivos
            </Typography>
          </Breadcrumbs>

          <Stack direction="row" alignItems="center" spacing={1.5}>
            <Avatar sx={{ bgcolor: '#f3e8ff', color: '#7e22ce', width: 36, height: 36 }}>
              <PrintIcon fontSize="small" />
            </Avatar>
            <Typography variant="h4" component="h1" sx={{ fontWeight: 700, color: '#111827' }}>
              Dispositivos
            </Typography>
          </Stack>

          <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
            Configure impressoras térmicas para impressão automática de comandas.
          </Typography>
        </Box>

        {/* Card Container Principal */}
        <Card sx={{ borderRadius: 3, boxShadow: '0 4px 20px rgba(0,0,0,0.05)', p: 2 }}>
          <CardContent>
            {/* Header: Toggle Geral de Impressoras */}
            <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 3 }}>
              <Stack direction="row" spacing={2} alignItems="center">
                <Avatar sx={{ bgcolor: '#f3e8ff', color: '#7e22ce', width: 44, height: 44 }}>
                  <PrintIcon />
                </Avatar>
                <Box>
                  <Typography variant="h6" sx={{ fontWeight: 700, fontSize: '1rem', color: '#111827' }}>
                    Impressoras
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Impressão automática de comandas
                  </Typography>
                </Box>
              </Stack>
              <Switch
                checked={impressorasAtivo}
                onChange={this.handleImpressorasChange}
                sx={{
                  '& .MuiSwitch-switchBase.Mui-checked': { color: '#7e22ce' },
                  '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': { backgroundColor: '#7e22ce' },
                }}
              />
            </Stack>

            {/* Banner de Status de Conexão */}
            <Box
              sx={{
                bgcolor: isConnected ? '#e6f4ea' : '#fef2f2',
                border: `1px solid ${isConnected ? '#a3e635' : '#fca5a5'}`,
                borderRadius: 2,
                p: 2,
                mb: 3,
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            >
              <Stack direction="row" spacing={1.5} alignItems="center">
                {isConnected ? (
                  <WifiIcon sx={{ color: '#16a34a', fontSize: 20 }} />
                ) : (
                  <WifiOffIcon sx={{ color: '#dc2626', fontSize: 20 }} />
                )}
                <Box>
                  <Typography
                    variant="subtitle2"
                    sx={{ fontWeight: 700, color: isConnected ? '#15803d' : '#b91c1c' }}
                  >
                    {isConnected
                      ? 'FazPedido Print conectado'
                      : isConnecting
                        ? 'Conectando ao agente de impressão...'
                        : 'Agente FazPedidoPrint desconectado'}
                  </Typography>
                  <Typography
                    variant="caption"
                    sx={{ color: isConnected ? '#16a34a' : '#dc2626' }}
                  >
                    {isConnected
                      ? `v${version} • Impressão automática ativa`
                      : 'Verifique se o agente local está em execução na porta 41520.'}
                  </Typography>
                </Box>
              </Stack>

              <Stack direction="row" spacing={1} alignItems="center">
                {isConnected && (
                  <Button
                    size="small"
                    variant="outlined"
                    color="success"
                    onClick={this.handleTestPrint}
                    sx={{ textTransform: 'none', borderRadius: 1.5 }}
                  >
                    Testar Impressão
                  </Button>
                )}
                <IconButton
                  size="small"
                  onClick={this.requestPrinterList}
                  disabled={!isConnected || isConnecting}
                  sx={{ color: isConnected ? '#16a34a' : '#dc2626' }}
                >
                  {isConnecting ? (
                    <CircularProgress size={18} color="inherit" />
                  ) : (
                    <AutorenewIcon fontSize="small" />
                  )}
                </IconButton>
              </Stack>
            </Box>

            {/* Seção: Seleção de Impressora */}
            <Typography variant="subtitle2" sx={{ fontWeight: 700, color: '#374151', mb: 1.5 }}>
              Selecione a Impressora
            </Typography>

            <Stack spacing={1.5} sx={{ mb: 4 }}>
              {!isConnected ? (
                <Typography variant="body2" color="text.secondary" sx={{ py: 2, textAlign: 'center' }}>
                  Conecte o agente para carregar as impressoras instaladas no sistema.
                </Typography>
              ) : printers.length === 0 ? (
                <Typography variant="body2" color="text.secondary" sx={{ py: 2, textAlign: 'center' }}>
                  Nenhuma impressora encontrada no sistema.
                </Typography>
              ) : (
                printers.map((printer, idx) => {
                  const isSelected =
                    selectedPrinter &&
                    (selectedPrinter.name === printer.name || selectedPrinter.device === printer.device);

                  return (
                    <Box
                      key={idx}
                      onClick={() => this.handleSelectPrinter(printer)}
                      sx={{
                        border: isSelected ? '2px solid #7e22ce' : '1px solid #e5e7eb',
                        borderRadius: 2,
                        p: 2,
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        bgcolor: isSelected ? '#faf5ff' : '#fff',
                        cursor: 'pointer',
                        transition: 'all 0.2s',
                        '&:hover': {
                          borderColor: '#7e22ce',
                        },
                      }}
                    >
                      <Stack direction="row" spacing={2} alignItems="center">
                        <Avatar
                          variant="rounded"
                          sx={{
                            bgcolor: isSelected ? '#f3e8ff' : '#f3f4f6',
                            color: isSelected ? '#7e22ce' : '#6b7280',
                            width: 40,
                            height: 40,
                          }}
                        >
                          <PrintIcon fontSize="small" />
                        </Avatar>
                        <Box>
                          <Typography variant="body2" sx={{ fontWeight: 600, color: '#111827' }}>
                            {printer.name}
                          </Typography>
                          <Typography variant="caption" color="text.secondary">
                            Porta/Dispositivo: {printer.device || 'N/D'}
                          </Typography>
                        </Box>
                      </Stack>

                      <Stack direction="row" spacing={1} alignItems="center">
                        {isSelected ? (
                          <Chip
                            icon={<CheckCircleIcon fontSize="small" />}
                            label="Selecionada"
                            size="small"
                            color="purple"
                            sx={{ bgcolor: '#7e22ce', color: '#fff', fontWeight: 600 }}
                          />
                        ) : (
                          <RadioButtonUncheckedIcon sx={{ color: '#9ca3af' }} />
                        )}
                      </Stack>
                    </Box>
                  );
                })
              )}
            </Stack>

            <Divider sx={{ my: 3 }} />

            {/* Seção: Opções de Impressão */}
            <Typography
              variant="caption"
              sx={{ fontWeight: 700, color: '#6b7280', letterSpacing: 0.5, display: 'block', mb: 2 }}
            >
              OPÇÕES DE IMPRESSÃO
            </Typography>

            <Box
              sx={{
                border: '1px solid #e5e7eb',
                borderRadius: 2,
                p: 2,
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            >
              <Stack direction="row" spacing={2} alignItems="center">
                <Avatar variant="rounded" sx={{ bgcolor: '#fef3c7', color: '#d97706', width: 40, height: 40 }}>
                  <FlashOnIcon fontSize="small" />
                </Avatar>
                <Box>
                  <Typography variant="body2" sx={{ fontWeight: 700, color: '#111827' }}>
                    Imprimir automaticamente novos pedidos
                  </Typography>
                  <Typography variant="caption" color="text.secondary">
                    Comanda impressa assim que o pedido for confirmado
                  </Typography>
                </Box>
              </Stack>
              <Switch
                checked={imprimirAutoAtivo}
                onChange={this.handleImprimirAutoChange}
                sx={{
                  '& .MuiSwitch-switchBase.Mui-checked': { color: '#7e22ce' },
                  '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': { backgroundColor: '#7e22ce' },
                }}
              />
            </Box>
          </CardContent>
        </Card>
      </Box>
    );
  }
}

export default DispositivosPage;